import { Terms } from "../../types/TermsTypes";
import { useCallback, useEffect, useState } from "react";
import { useUserSessionContext } from "../../contexts/UserSessionContext";
import { ERRORS } from "../../types/Errors";
import { useErrorBoundary } from "react-error-boundary";
import { useGetTermsAndConditions } from "../useGetTermsAndConditions";
import { usePostTermsAndConditions } from "../usePostTermsAndConditions";
import { useHttpErrorHandler } from "../useHttpErrorHandler";
import { ForbiddenError } from "../../utils/HttpError";

export const useTermsAndConditions = () => {
  const { showBoundary } = useErrorBoundary();
  const { logoutUser } = useUserSessionContext();
  const { fetch: getTermsAndConditions, loading: isLoadingTerms } = useGetTermsAndConditions();
  const { fetch: postAcceptTermsAndConditions, loading: isUpdatingTerms } = usePostTermsAndConditions();
  const [termsAndConditions, setTermsAndConditions] = useState<Terms>();
  const [isLoadingTermsAndConditions, setIsLoadingTermsAndConditions] = useState(false);
  const { handleHttpError } = useHttpErrorHandler();
  const declineTermsAndConditions = useCallback(() => {
    logoutUser();
  }, [logoutUser]);

  const approveTermsAndConditions = useCallback(() => {
    postAcceptTermsAndConditions()
      .then((res) => {
        if (res && res.data) {
          setTermsAndConditions({
            accepted: res.data,
          });
        }
      })
      .catch((error) => {
        handleHttpError(error);
      });
  }, [handleHttpError, postAcceptTermsAndConditions]);

  useEffect(() => {
    getTermsAndConditions()
      .then((res) => {
        if (res?.data) {
          setTermsAndConditions(res.data);
        }
      })
      .catch((error) => {
        if (error instanceof ForbiddenError) {
          setTimeout(() => alert(ERRORS.TRAINING_REQUIRED), 1);
        }

        showBoundary(error);
      });
  }, [getTermsAndConditions, showBoundary]);

  useEffect(() => {
    setIsLoadingTermsAndConditions(isLoadingTerms || isUpdatingTerms);
  }, [isLoadingTerms, isUpdatingTerms]);

  return {
    termsAndConditions,
    isLoadingTermsAndConditions,
    declineTermsAndConditions,
    approveTermsAndConditions,
  };
};
